import $ from 'jquery';

$(document).ready(function() {
	$('.b-museum-reviews__text').each(function() {
		if ($(window).width() > 1023) {
			if ($(this).height() >= 190) {
				$(this).parents('.b-museum-reviews__wrap').addClass('more');
			}
		} else {
			if ($(this).height() >= 118) {
				$(this).parents('.b-museum-reviews__wrap').addClass('more');
			}
		}
	});
	$(document).on('click', '.js-museum-reviews-more', function() {
		$(this).parents('.b-museum-reviews__wrap').removeClass('more');
		$(this).parents('.b-museum-reviews__wrap').find('.b-museum-reviews__text').addClass('show');
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-reviews.js